<template>
	<div class="certificate-list">
		<b-card header-tag="header" footer-tag="footer">
			<transition name="slide" mode="out-in">
				<div class="filter-frame" v-if="isDropped">
					<b-row class="my-1">
						<b-col sm="3">
							<label for="fromDate">
								{{$t('certificate.fromDate')}}
							</label>
							<b-input-group size="sm" class="mb-3">
								<masked-input
									id="fromDate"
									v-model="fromDate"
								    mask="11-11-1111"
								    class="ml-1 form-control form-control-sm"
								    :placeholder="$t('certificate.fromDate')"
								/>
								<b-input-group-addon>
									<b-button size="sm" disabled>
										<i class="fa fa-calendar"></i>
									</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-col>
						<b-col sm="3">
							<label for="toDate">
								{{$t('certificate.toDate')}}
							</label>
							<b-input-group size="sm" class="mb-3">
								<masked-input v-model="toDate"
											  id="toDate"
											  mask="11-11-1111"
											  class="ml-1 form-control form-control-sm"
											  :placeholder="$t('certificate.toDate')"/>
								<b-input-group-addon>
									<b-button size="sm" disabled>
										<i class="fa fa-calendar"></i>
									</b-button>
								</b-input-group-addon>
							</b-input-group>
						</b-col>
						<b-col sm="3">
							<label for="input-small">
								{{$t('pricing.department')}}
							</label>
							<multiselect
								v-model="selectedDepartment"
								:options="getDepartmentsLocal()"
								:multiple="true"
								:group-select="true"
								track-by="id"
								label="name"
								:show-labels="false"
								:allow-empty="true"
								class="multiselect-pricing"
							>
								<span slot="noResult">Oops! No elements found. Consider changing the search query.</span>
							</multiselect>
						</b-col>
						<b-col sm="3">
							<label for="input-small">
								<span>
									{{$t('certificate.packageName')}}
								</span>
							</label>
							<b-input-group
								size="sm"
								class="mb-3"
							>
								<b-form-input
									:placeholder="$t('certificate.packageName')"
									v-model="packageName"
									autocomplete="off"
									type="text"
								>
								</b-form-input>
							</b-input-group>
						</b-col>
					</b-row>
					<div class="search_btn">
						<b-button variant="dark" @click="search">
							<span>
								<i class="fa fa-search"></i>
								{{$t('certificate.search')}}
							</span>
						</b-button>
					</div>
				</div>
			</transition>
			<div slot="header" class="top-card">
				<span>
					<h5>{{$t('sidebar.pos.certificates')}}</h5>
				</span>
				<div>
					<b-button variant="secondary" class="certificateGenerate" @click.prevent="openSearchForm">
						<i class="fa fa-search-plus"></i>
					</b-button>
					<b-button variant="secondary" class="certificateGenerate" @click.prevent="openSidebar">
						<i class="fa fa-plus"></i>
					</b-button>
				</div>
			</div>
			<b-table class="generalTableClass"
					 hover="hover"
					 striped="striped"
					 bordered="bordered"
					 small="small"
					 fixed="fixed"
					 :items="getCertificates.items"
					 responsive="sm"
					 :fields="computedFields"
			>
				<template slot="id" slot-scope="data">
					<strong>{{ data.index + 1}}</strong>
				</template>
				<template slot="expiredDate" slot-scope="data">
					{{ data.item.expiredDate }}
				</template>
				<template slot="department" slot-scope="data">
					<div v-for="(department,index) in data.item.departmentName">
						<em>{{index + 1}}</em>.{{department}}
					</div>
				</template>
				<template slot="modify" slot-scope="data">
					<i class="fa fa-edit editBtn" @click.prevent="editBtn(data.item.certificatePackageName)"></i>
				</template>
			</b-table>
			<nav>
				<b-pagination
					size="sm"
					:total-rows="getCertificates.total"
					:per-page="perPage"
					v-model="currentPage"
					:prev-text="$t('pagination.prev')"
					:next-text="$t('pagination.next')"
					hide-goto-end-buttons
				/>
			</nav>
		</b-card>

		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeSidebar"
			:click-not-close="true"
		>
			<CertificateGenerate @closeSidebar="closeSidebar"></CertificateGenerate>
		</vs-sidebar>
		<vs-sidebar
			position-right
			parent="body"
			default-index="1"
			color="primary"
			class="create-modal priceSidebar"
			spacer
			v-model="activeEditSidebar"
			:click-not-close="true"
		>
			<CertificateEdit @closeEditSidebar="closeEditSidebar"></CertificateEdit>
		</vs-sidebar>
	</div>
</template>

<script>
	import {mapActions, mapGetters} from "vuex";
	import MaskedInput from 'vue-masked-input'
	import Multiselect from 'vue-multiselect'
	import CertificateGenerate from './CertificateGenerate'
	import CertificateEdit from './CertificateEdit'
	export default{
		components:{
			CertificateGenerate,
			MaskedInput,
			Multiselect,
			CertificateEdit
		},
		data(){
			return{
				items:[],
				activeSidebar:false,
				activeEditSidebar:false,
				currentPage: 1,
				perPage: 20,
				fromDate:null,
				toDate:null,
				isDropped: false,
				selectedDepartment:[],
				cerfNumber:'',
				packageName:null
			}
		},
		watch: {
			currentPage: {
				async handler() {
					let data = {
						page: this.currentPage,
						limit: this.perPage
					};
					await this.getCertificateList(data);
				}
			}
		},
		methods:{
			async search(){
				if(this.selectedDepartment.length > 0){
					const departments = this.selectedDepartment.map((department) => {
						return department.id
					});
					let data = {
						page: this.currentPage,
						limit: this.perPage,
						department:departments,
						packageName:this.packageName,
						dateStart:this.fromDate,
						dateEnd:this.toDate
					};
					await this.getCertificateList(data);
				}else{
					let data = {
						page: this.currentPage,
						limit: this.perPage,
						department:null,
						packageName:this.packageName,
						dateStart:this.fromDate,
						dateEnd:this.toDate
					};
					await this.getCertificateList(data);
				}

			},
			getDepartmentsLocal() {
				return this.getDepartments
			},
			openSearchForm(){
				this.isDropped = !this.isDropped
			},
			closeEditSidebar(){
				this.activeEditSidebar = false
			},
			async editBtn(name){
				this.activeEditSidebar = true
				let data={
					page: this.currentPage,
					limit: this.perPage,
					packageName:name
				}
				await this.getEditCertificateList(data)
			},
			async closeSidebar(){
				let data = {
					page: this.currentPage,
					limit: this.perPage
				};
				await this.getCertificateList(data);
				this.activeSidebar = false
			},
			...mapActions('certificates', [
				'getCertificateList','getEditCertificateList'
			]),
			...mapActions('prices', [
				'getDepartmentList'
			]),
			openSidebar() {
				this.activeSidebar = true
			},
		},
		computed:{
			...mapGetters('certificates', [
				'getCertificates','getEditCertificate'
			]),
			...mapGetters('prices', [
				'getDepartments',
			]),
			computedFields() {
				return [
					{
						key: 'id',
						label: this.$t('users-l.Id'),
						'class': 'role_id',
						sortable: true
					},
					{
						key: 'certificatePackageName',
						label: this.$t('certificate.packageName'),
					},
					{
						key: 'department',
						label: this.$t('certificate.departmentName'),
					},
					{
						key: 'count',
						label: this.$t('certificate.count'),
					},
					{
						key: 'startDate',
						label: this.$t('certificate.date'),
					},
					{
						key: 'expiredDate',
						label: this.$t('certificate.expirationDate'),
					},
					{
						key: 'modify',
						label: this.$t('actions.title'),
					},
				]
			},
		},
		async created(){
			// Certificate List actions
			let data = {
				page: this.currentPage,
				limit: this.perPage
			};
			await this.getCertificateList(data);

		},
		async mounted(){
			await this.getDepartmentList()

			// functions from methods
			this.getDepartmentsLocal()
		},
	}
</script>

<style scoped>
	.editBtn{
		font-size: 14px;
		cursor: pointer;
	}
	.filter-frame{
		padding-bottom:15px;
	}
	.slide-enter, .slide-leave-to{
		transform: scaleY(0);
	}
	.certificateGenerate{
		background: transparent !important;
		border: none;
		padding: 7px;
		font-size: 16px;
	}
	.certificateGenerate span{
		margin-left: 5px;
	}
	.top-card{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.search_btn{
		width: 100%;
		display: flex;
		justify-content: flex-end;
		padding-right: 25px
	}
	input[type=number]::-webkit-inner-spin-button,
	input[type=number]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
</style>
